import { render, staticRenderFns } from "./AccountTabsMenu.vue?vue&type=template&id=23e523d3&scoped=true&"
import script from "./AccountTabsMenu.vue?vue&type=script&lang=ts&"
export * from "./AccountTabsMenu.vue?vue&type=script&lang=ts&"
import style0 from "./AccountTabsMenu.vue?vue&type=style&index=0&id=23e523d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e523d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VAvatar,VBtn,VCol,VLayout,VRow,VThemeProvider})
